import 'regenerator-runtime/runtime';
import { call, put } from 'redux-saga/effects';

import { handleGenericError } from '../common';
import { makeRequest } from './horizon';
import { actions } from '../../reducers/iot/iot';

export default function* resumePrint(action) {
  const { device } = action.payload;

  try {
    const deviceType = device.type;

    yield call(
      makeRequest,
      device.id,
      deviceType === 'canvas-hub' ? 'printer/resume' : 'printer/print/resume',
      {
        method: 'post',
      },
      'resumePrint'
    );
    yield put(actions.resumePrintSuccess());
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
